














































































































import Vue from "vue";
import filterWindow from "./components/FilterWindow.vue";

export default Vue.extend({
  name: "App",
  components: { filterWindow },
  data: () => ({
    cookiesClaim: false,
    showInstallIOS: false,
    showDrawer: false,
    showFilter: false,
    searchText: "",
    items: [
      {
        name: 'messages',
        title: "Komunikaty",
        icon: "mdi-message-text-outline",
        uri: "/messages",
        bgColor: "#8c0d6e",
        color: "#ffffff"
      },
      {
        name: 'airquality',
        title: "Jakość powietrza",
        icon: "mdi-weather-windy",
        uri: "/airquality",
        bgColor: "#94a60d",
        color: "#ffffff"
      },
      {
        name: 'waterlevel',
        title: "Poziom wód",
        icon: "mdi-weather-sunset",
        uri: "/waterlevel",
        bgColor: "#45a3c2",
        color: "#ffffff"
      },
      {
        name: "stats",
        title: "Informacje statyczne",
        icon: "mdi-sign-caution",
        uri: "/stats/0",
        bgColor: "#bd0512",
        color: "#ffffff"
      }
    ]
  }),
  mounted() {
    this.cookiesClaim = (sessionStorage.getItem("cookiesApproved") !== "true");
    if(!this.cookiesClaim) //&& (sessionStorage.getItem("installShowed") == "true"))
      this.checkIOS();
  },
  methods: {
    checkIOS() {
        // Detects if device is on iOS 
        const isIos = () => {
          const userAgent = window.navigator.userAgent.toLowerCase();
          console.log(userAgent);
          return /iphone|ipad|ipod/.test( userAgent );
        }
        // Detects if device is in standalone mode
        const isInStandaloneMode = () => (window.matchMedia('(display-mode: standalone)').matches);

        // Checks if should display install popup notification:
        if (isIos() && !isInStandaloneMode()) {
          console.log("show install message");
          this.showInstallIOS = true;
          sessionStorage.setItem("installShowed", "true");
          setTimeout(() => (this.showInstallIOS = false), 5000);
        }
    },
    acceptCookiesClaim() {
      sessionStorage.setItem("cookiesApproved", "true");
      this.cookiesClaim = !this.cookiesClaim;
    },
    clearMessage () {
        this.searchText = "";
        this.$store.commit("SET_FILTER", "");
    },
    redirectToMessages() {
      var ef = encodeURI(this.searchText);
      var ts = Date.now();
      if(this.$route.name != "messages")
      this.$router.push({
        name: "messages",
        params: { filter: ef }
      });
      this.$store.commit("SET_FILTER", ef);
    }
  }
});
